// @flow strict
/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
import * as React from 'react';
import Modal from '@ta/modal.styleguide';
import Localize from '@ta/platform.i18n';
import { RadioGroup } from '@ta/core-ui.radio-button';
import { TitleBar } from '@ta/modal.headers';
import ReportVoteThankYou from './ReportVoteThankYou';
import ReportVoteError from './ReportVoteError';
import styles from './ReportModal.css';

/**
 * The different stages the ReportModal can be in
 */
export type ReportStage = 'panel' | 'thankyou' | 'error';

type Props = {|
  stage: ReportStage,
  onClose?: () => mixed,
  children: React.Node,
|};

const ReportModal = ({ stage, onClose, children }: Props) => (
  <Modal
    header={
      <TitleBar iconName="flag-fill" displayType="LEFT_ALIGN_GRAY">
        <div id="ReportIAP">
          <Localize id="report_problem_ffffff85" />
        </div>
      </TitleBar>
    }
    onClose={onClose}
  >
    {stage === 'thankyou' && <ReportVoteThankYou />}
    {stage === 'error' && <ReportVoteError />}
    {stage === 'panel' && (
      <div className={styles.iapModalContent}>
        <RadioGroup name="ReportIAP" labelId="ReportIAP">
          {children}
        </RadioGroup>
      </div>
    )}
  </Modal>
);

export default ReportModal;
